import { render, staticRenderFns } from "./ownerdeskdetails.vue?vue&type=template&id=bf6fc1de&scoped=true&"
import script from "./ownerdeskdetails.vue?vue&type=script&lang=js&"
export * from "./ownerdeskdetails.vue?vue&type=script&lang=js&"
import style0 from "./ownerdeskdetails.vue?vue&type=style&index=0&id=bf6fc1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6fc1de",
  null
  
)

export default component.exports